<section class="real-estate-shell">
    <main class="workspace">
        <header class="object-header">
            <div class="title-group">
                <button class="back-button">‹</button>
                <img class="title-thumb" src="assets/building.svg" alt="Santis Office Tower" />
                <div>
                    <div class="headline-row">
                        <h1>Santis Office Tower</h1>
                        <span class="asset-pill">Real estate</span>
                        <strong>Invested by: <span>Santis Family Office</span></strong>
                    </div>
                    <nav class="top-tabs">
                        <button *ngFor="let tab of tabs; let i = index" class="tab" [class.active]="i === 0">
                            {{ tab }}
                        </button>
                    </nav>
                </div>
            </div>

            <div class="header-actions">
                <button class="primary-button">▣ New transaction</button>
                <button class="dark-button">＋ Property</button>
                <button class="icon-button">✎</button>
                <button class="icon-button">▧</button>
                <button class="icon-button ghost">⋮</button>
            </div>
        </header>

        <section class="page-body">
            <aside class="side-panel">
                <button class="tag-button">Add Tags +</button>
                <img class="building-image" src="assets/building.svg" alt="Office building" />
                <nav class="section-nav">
                    <a *ngFor="let item of navItems; let i = index" [class.active]="i === 2 || i === 3">
                        {{ item }}
                    </a>
                </nav>
            </aside>

            <section class="content-area">
                <article class="card info-card">
                    <h2>Real Estate Information</h2>
                    <div class="info-grid">
                        <div *ngFor="let item of infoItems" class="info-item">
                            <dt>{{ item.label }} <span *ngIf="item.hint" class="hint">ⓘ</span></dt>
                            <dd>{{ item.value }}</dd>
                        </div>
                    </div>
                </article>

                <article class="card rentals-card">
                    <div class="card-heading">
                        <h2>Rental Units</h2>
                        <div class="table-tools">
                            <button class="link-tab active">At date</button>
                            <button class="link-tab">Sub units</button>
                        </div>
                    </div>

                    <label class="date-filter">
                        <span>Show occupation at date</span>
                        <div class="date-input">▣ 05/02/2025</div>
                    </label>

                    <div class="table-wrapper">
                        <table>
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>Type</th>
                                <th>m²</th>
                                <th>rent/mo net</th>
                                <th>add. exp./mo</th>
                                <th>heat. costs/mo</th>
                                <th>power<br />costs/mo</th>
                                <th>rent total/mo</th>
                                <th>price/m²</th>
                                <th>Deposit</th>
                                <th>Ledger<br /><small>Ledger ID</small></th>
                                <th>From<br /><small>Until</small></th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let unit of rentalUnits">
                                <td><strong>{{ unit.name }}</strong></td>
                                <td>{{ unit.type }}</td>
                                <td class="num">{{ unit.area }}</td>
                                <td class="num">{{ unit.rentNet }}</td>
                                <td class="num">{{ unit.additionalExpenses }}</td>
                                <td class="num">{{ unit.heatingCosts }}</td>
                                <td class="num">{{ unit.powerCosts }}</td>
                                <td class="num">{{ unit.rentTotal }}</td>
                                <td class="num">{{ unit.pricePerM2 }}</td>
                                <td class="num">{{ unit.deposit }}</td>
                                <td>{{ unit.ledger }}</td>
                                <td>
                                    <strong>{{ unit.from }}</strong>
                                    <span>{{ unit.until }}</span>
                                </td>
                                <td class="row-actions"><button>✎</button></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </article>

                <article class="card placeholder-card"></article>
            </section>
        </section>
    </main>
</section>
